import { AsyncEvent } from 'ts-events';
export class MediaboxService {
    evtMediaChanged = new AsyncEvent();
    data = null;
    caption = '';
    filename = '';
    mimetype = '';
    setMedia(data, filename, mimetype, caption) {
        this.data = data;
        this.filename = filename;
        this.mimetype = mimetype;
        this.caption = caption;
        this.evtMediaChanged.post(data !== null);
    }
    clearMedia() {
        this.data = null;
        this.filename = '';
        this.mimetype = '';
        this.caption = '';
        this.evtMediaChanged.post(false);
    }
}
